/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { DashboardWidgetsCode, WidgetsDto } from '../dto';

export const WidgetsMapper = entity<WidgetsDto>({
  code: enumeration(DashboardWidgetsCode),
});
